import { useMemo } from 'react'
import { useDrawer } from '@/core/context/DrawerContext'
import { PlusIcon } from '@atbay/icons'
import PageActionButton from '@components/buttons/page-action'
import DashboardPage from '@components/pages/dashboard'
import { SettingsTeamModule } from '@core/modules/team/team.module'
import { unifiedTeamFilterModule } from '@core/modules/team/team.filters'
import { useUnifiedFilter } from '@core/hooks/useUnifiedFilter'
import { Analytics } from '@core/services/mixpanel'
import { TableWrapper } from '@/ui/components/CustomTable/CustomTable.styles'
import TeamPageHeader from '@routes/settings/routes/team/components/header'
import TeamSkeleton from '@routes/settings/routes/team/components/skeleton'
import TeamTable from '@routes/settings/routes/team/components/table/TeamTable'

export const PageActions = () => {
    const { setDrawerState } = useDrawer()

    const openFilterDrawer = () => {
        Analytics.event('SEM::user_opens_invite_drawer', {
            origin: 'team-settings-page',
        })

        setDrawerState((prevState) => ({
            ...prevState,
            isDrawerOpen: true,
            drawerContentType: 'inviteUser',
            contentProps: {
                width: '30vw',
            },
        }))
    }

    return (
        <PageActionButton
            label="Invite new user"
            action={openFilterDrawer}
            icon={<PlusIcon />}
        />
    )
}

const TeamPage = () => {
    const { loading, data } = SettingsTeamModule.useStore()
    const members = useMemo(() => Object.values(data), [data])

    const { data: filteredMembers } = useUnifiedFilter({
        filterModule: unifiedTeamFilterModule,
        data: members,
    })

    return (
        <DashboardPage
            name="settings-team"
            pageActions={<PageActions />}
            loading={loading}
            skeleton={<TeamSkeleton />}
        >
            <TableWrapper>
                <TeamPageHeader />
                <TeamTable data={filteredMembers} />
            </TableWrapper>
        </DashboardPage>
    )
}

export default TeamPage
